import { Box, Grid, IconButton, Stack, styled } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  CardVariant,
  WsCard,
  WsColors,
  WsTypography,
  WsTypoVariants,
  WsTitleBanner,
} from 'wisestep-base';

import { accessDeniedNotoficationTxt } from '../../../../components/AccessControl/AccessControl';
import { ActivateFeature } from '../../../../components/ActivateFeature';
import { CandidateAtsAccess, useCandidateAts } from '../../../../hooks/useCandidateAts';
import chrome from '../../../../images/chrome.png';
import folderIcon from '../../../../images/folderIcon.png';
// import googleDrive from '../../../../images/googleDrive.png';
import outlook from '../../../../images/outlook.png';
import spreadsheets from '../../../../images/spreadsheets.png';
import { warning } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';

const BulkUploadIndex = () => {
  const titles = [
    'Upload CVs',
    // 'Upload CVs',
    'Upload candidates info',
    'Post jobs and upload candidates',
    'Parse and upload CVs from browser',
  ];
  // const subTitles = ['Your Device', 'Google Drive', 'Spreadsheets', 'Outlook', 'Browser Extension'];
  // const uploadIcons = [folderIcon, googleDrive, spreadsheets, outlook, chrome];
  const subTitles = ['Your Device', 'Spreadsheets', 'Outlook', 'Browser Extension'];
  const uploadIcons = [folderIcon, spreadsheets, outlook, chrome];
  const [params] = useSearchParams();
  const jobId = String(params.get('jobId') ?? '');

  const LayoutTheme = styled(Box)(() => ({
    maxWidth: '100%',
    maxHeight: 'xs',
    backgroundColor: WsColors.TertiaryShades50,
    padding: 2,
  }));
  const isLocalImport = useCandidateAts(CandidateAtsAccess.LOCAL_IMPORT);
  // const isGdriveImport = useCandidateAts(CandidateAtsAccess.GDRIVE_IMPORT);
  const isExcelImport = useCandidateAts(CandidateAtsAccess.EXCEL_IMPORT);
  const setNotification = useNotificationStore((state) => state.setNotification);

  const handleNavigation = {
    [0]: () =>
      isLocalImport
        ? navigate(`/import-candidates/bulk-upload-to-cv-parser?jobId=${jobId}`)
        : setNotification(warning(accessDeniedNotoficationTxt)),
    // [1]: () =>
    //   isGdriveImport
    //     ? navigate('/import-candidates/bulk-upload-to-cv-parser/google-drive')
    //     : setNotification(warning(accessDeniedNotoficationTxt)),
    [1]: () =>
      isExcelImport
        ? navigate(`/import-candidates/bulk-upload-excel?jobId=${jobId}`)
        : setNotification(warning(accessDeniedNotoficationTxt)),
    [2]: () =>
      window.open('https://appsource.microsoft.com/en-us/product/office/WA200002649?tab=Overview'),
    [3]: () =>
      window.open(
        'https://chrome.google.com/webstore/detail/recruitment-automation-by/dhbkmcoahmolllnkkpgniamjkldaemgm'
      ),
  };
  const navigate = useNavigate();

  const featureCodes = ['CS_UPLOAD_AND_PARSE_CV', 'CS_UPLOAD_AND_PARSE_CV', 'CS_UPLOAD_EXCEL'];

  const getCard = (index: number, title: string) => (
    <Box
      mx={2}
      my={1}
      sx={{
        cursor: 'pointer',
      }}
    >
      <WsCard
        cardType={CardVariant.WITH_OUT_BG}
        title={title}
        onClick={() => handleNavigation[index]()}
        middleComponent={
          <Stack direction="column" maxHeight="60px">
            <IconButton>
              <img src={uploadIcons[index]} alt={subTitles[index]} />
            </IconButton>
            <WsTypography variant={WsTypoVariants.TITLE} bold={true} cursor="pointer">
              {subTitles[index]}
            </WsTypography>
          </Stack>
        }
        isButton={true}
      />
    </Box>
  );
  const cardHeight = '200px';

  const cardStyle = {
    height: cardHeight,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginBottom: '20px',
  };

  return (
    <LayoutTheme>
      <WsTitleBanner title="Import Candidates" goBack={() => navigate('/')} />
      <Grid container spacing={1} justifyContent="center" pt={4}>
        <Grid item xs={12} alignContent="flex-start" pb={1}>
          <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
            Pick your option to upload candidate details
          </WsTypography>
        </Grid>
        {titles.map((title, index) => (
          // Set a fixed height for the cards
          <Grid item xs={6} key={index} sx={{ ...cardStyle }}>
            <>
              {index < 3 ? (
                <ActivateFeature feature={featureCodes[index]}>
                  {index == 0 && getCard(index, title)}
                  {index == 1 && getCard(index, title)}
                  {index == 2 && getCard(index, title)}
                  {index == 3 && getCard(index, title)}
                  {index > 3 && getCard(index, title)}
                </ActivateFeature>
              ) : (
                <Box>
                  {index == 0 && getCard(index, title)}
                  {index == 1 && getCard(index, title)}
                  {index == 2 && getCard(index, title)}
                  {index == 3 && getCard(index, title)}
                  {index > 3 && getCard(index, title)}
                </Box>
              )}
            </>{' '}
          </Grid>
        ))}
      </Grid>
    </LayoutTheme>
  );
};

export default BulkUploadIndex;
